import { GetInitialDataCtx, WidgetProps } from "../../contracts/widget"
import { amenitiesWidgetConfig, AmenitiesWidgetConfig } from "./config"
import { WidgetProvider } from "../../providers/widget"
import { AmenitiesWidgetContent } from "./components/AmenitiesWidgetContent"
import "./amenities.css"
import { useMemo } from "react"
import { parseWidgetConfig } from "@homerunner-next/widget-core/schema"

export const getInitialData = async ({ options, feedId, widgetId }: GetInitialDataCtx<AmenitiesWidgetConfig>) => {
    return {}
}

export default function AmenitiesWidget({ options, feedId, widgetId, resolvedTheme, data }: WidgetProps<AmenitiesWidgetConfig>) {
    const parsedOptions = useMemo(() => parseWidgetConfig(amenitiesWidgetConfig, options), [options])
    return (
        <WidgetProvider options={parsedOptions} feedId={feedId} widgetId={widgetId} resolvedTheme={resolvedTheme} widgetType="amenities" data={data ?? {}}>
            <AmenitiesWidgetContent />
        </WidgetProvider>
    )
}
